/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const CONFIGURATION_QUERY = {
	BY_CONFIGURATION_IDS: 'byConfigurationIds',
	ALL: 'all',
};
